export default __webpack_public_path__ + "static/media/Caroll.f916b6e1.png";